
/**
 * 判断是否是百福德环境或者是maxapp
 */
export function BFD_checkApp() {
    return window.navigator.userAgent.indexOf('BFD-APP') > -1||window.navigator.userAgent.indexOf('MAX-APP') > -1
}

/**
 * 判断是否是官网app
 */
 export function DF_checkApp() {
    return window.navigator.userAgent.indexOf('MAX-APP') > -1
}

/**
 * 加载js依赖文件
 */
export function loadFUNJS() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'http://static.dongfangfuli.com/info/bridge/1.0/prd/app_bridge.min.js';
    document.head.appendChild(script);
    console.log('loadFUNJS11')
}

/**
 * 跳转至app页面
 * @param {*} pathKey 原生页面key
 *  'city'        //城市选择页
    'user'        //个人中心页
    'userdetail'  //个人详情
    'balance'     //账户余额
    'setting'     //设置页
    'about'       //关于
    'feedback'    //意见反馈
 */
export function BFD_goToAppPage(pathKey) {
    try {
        const params = {
            pageName: pathKey,
            pageData: ''
        }
        console.log('跳转原生', window.dfwAppclass)
        window.dfwAppclass.DFWUtils.appShowPage(params, function (respData) {
            var infoStr = JSON.stringify(respData)
            console.log('appShowPage', infoStr)
        })
    } catch (e) {
        console.log('跳转原生异常', e)
        return false;
    }
    return true;
}
export function BFD_LoginOut() {
    try {
        const params = {
            type: 'tokenTimeout',
        }
        console.log('跳转登陆页', window.dfwAppclass)
        window.dfwAppclass.DFWUtils.appRelogin(params, function (respData) {
            var infoStr = JSON.stringify(respData)
            console.log('appRelogin', infoStr)
        })
    } catch (e) {
        console.log('跳转登陆页', e)
        return false;
    }
    return true;
}
